export { default } from './Avatar';
export type { Flair } from './AvatarFlair';
